import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import * as Sentry from "@sentry/react";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "@fontsource/inter/400.css";
import "@fontsource/inter/700.css";
import { initConsoleReporter } from "./services/logging/consoleReporter";

if (
  window.location.protocol === "http:" &&
  (window.location.hostname === "localhost" ||
    window.location.hostname === "127.0.0.1")
) {
  window.location.replace(
    `https://${window.location.host}${window.location.pathname}${window.location.search}${window.location.hash}`
  );
}

// Initialize Sentry only in production/staging
if (
  process.env.NODE_ENV === "production" ||
  process.env.REACT_APP_ENV === "staging"
) {
  Sentry.init({
    dsn: "https://4c4fef0a48d06bd9bd19152dccae490f@o4509323998789632.ingest.us.sentry.io/4509992157773824",
    // Setting this option to true will send default PII data to Sentry.
    // For example, automatic IP address collection on events
    sendDefaultPii: true,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration(),
      // Send console.log, console.warn, and console.error calls as logs to Sentry
      Sentry.consoleLoggingIntegration({ levels: ["log", "warn", "error"] }),
    ],
    // Set release version to match the one used during build
    release: process.env.REACT_APP_VERSION || Date.now().toString(),
    environment: process.env.NODE_ENV || "development",
    // Enable logging
    enableLogs: true,
    // Performance Monitoring
    tracesSampleRate: 1.0, // Capture 100% of the transactions for performance monitoring in production
    // Session Replay
    replaysSessionSampleRate: 0.1, // Sample 10% of sessions
    replaysOnErrorSampleRate: 1.0, // Sample 100% of sessions with an error
  });
}

initConsoleReporter();

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <React.StrictMode>
    <Sentry.ErrorBoundary
      fallback={<div>An error has occurred</div>}
      showDialog
    >
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </Sentry.ErrorBoundary>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
